<template>
  <div class="pa-4 overflow-auto" style="height:100%">
    <h2 class="mb-4">User details</h2>
    <v-form ref="userForm">
      <v-text-field
        label="First name"
        v-model="user.firstName"
        outlined
        autocomplete="off"
        :disabled="!allowEditing"
      ></v-text-field>
      <v-text-field
        label="Last name"
        v-model="user.lastName"
        outlined
        autocomplete="off"
        :disabled="!allowEditing"
      ></v-text-field>
      <v-text-field
        label="Title"
        v-model="user.title"
        outlined
        autocomplete="off"
        :disabled="!allowEditing"
      >
      </v-text-field>
      <v-text-field
        label="Organization"
        v-model="user.organization"
        outlined
        autocomplete="off"
        :disabled="!allowEditing"
      ></v-text-field>
      <v-text-field
        label="Email"
        type="email"
        v-model="user.email"
        :rules="[rules.required]"
        outlined
        autocomplete="off"
        :disabled="!allowEditing"
      ></v-text-field>
      <v-select
        label="Area(s)"
        multiple
        :items="getAreas"
        v-model="user.areas"
        item-text="name"
        item-value="id"
        outlined
        autocomplete="off"
        :disabled="!allowEditing"
      ></v-select>
      <v-select
        label="Role(s)"
        multiple
        :items="getRoles"
        v-model="roles"
        item-text="name"
        item-value="id"
        outlined
        autocomplete="off"
        :disabled="!allowEditing"
      ></v-select>
      <v-text-field
        v-if="!user.id"
        label="Password"
        v-model="user.password"
        outlined
        :type="showPw ? 'text' : 'password'"
        :append-icon="showPw ? 'mdi-eye' : 'mdi-eye-off'"
        :rules="[rules.required, rules.min]"
        @click:append="showPw = !showPw"
        counter
        hint="At least 8 characters"
        autocomplete="off"
        :disabled="!allowEditing"
      ></v-text-field>
      <v-btn color="primary" v-on:click="saveUser()" :disabled="!allowEditing">Save user</v-btn>
    </v-form>
  </div>
</template>
<script>
import jwt_decode from "jwt-decode";

export default {
  name: "UserEdit",
  props: {
    user: {
      id: {
        type: "string"
      },
      firstName: {
        type: "string"
      },
      lastName: {
        type: "string"
      },
      title: {
        type: "string"
      },
      organization: {
        type: "string"
      },
      email: {
        type: "string"
      },
      areas: {
        type: "array"
      },
      roles: {
        type: "array"
      }
    },
  },
  data() {
    return {
      showPw: false,
      rules: {
        required: value => !!value || 'Field required.',
        min: v => (v && v.length >= 8) || 'Min length 8 characters.'
      },
      roles: []
    };
  },
  mounted(){
    this.getUserRoles();
  },
  watch: {
    user: function (newVal, oldVal) {
      this.getUserRoles();
    },
  },
  computed: {
    getAreas() {
      return this.$store.state.mapData;
    },
    getRoles() {
      return [
        {
          name: "User",
          id: "user",
        },
        {
          name: "Jobster",
          id: "jobster",
        },
        {
          name: "Admin",
          id: "superadmin",
        },
      ];
    },
    allowEditing(){
      // Allow editing for superadmins or for personal profile
      let currentRoles = this.$store.state.userRoles.inherits;
      let userId = jwt_decode(this.$store.state.JWT).sub;
      console.log(userId, currentRoles);
      return (currentRoles.includes("superadmin") || userId == this.user.id) ? true : false;
    }
  },
  methods: {
    saveUser() {
      let profile = {
        areas: [],
        email: this.user.email.toLowerCase(),
        firstName: this.user.firstName,
        id: this.user.id,
        lastName: this.user.lastName,
        organization: this.user.organization,
        title: this.user.title
      };

      this.user.email = this.user.email.toLowerCase();

      profile.areas = this.user.areas.map((area) => {
          let nArea;
          if(typeof area == "object"){
            nArea = this.getAreas.find(a => a.id == area.id);
          } else {
            nArea = this.getAreas.find(a => a.id == area);
          }
          return { id: nArea.id, name: nArea.name };
        });

      // Update existing user profile
      if(this.user.id){

        let payload = profile;

        console.log(this.roles);

        this.$store.dispatch("dispatchPutUser", { id: profile.id, userData: payload }).then((user) => {
          // this.$emit("saved", user);
          this.$store.dispatch("commitSnackbar", { show: true, message: "User details updated", timeout: 4000, color: "primary" });
        });

        // Update user role
        let rolePayload = {
          id: profile.id,
          type: "private",
          inherits: this.roles,
          abilities: []
        }
        this.$store
          .dispatch("dispatchPutUserRoles",
          { userId: profile.id, userRoles: rolePayload })
          .then(() => {
            console.log("user roles updated");
          });

      }
      // Create new user
      else {

        let payload = {
          credentials: {
            identifier: this.user.email,
            password: this.user.password
          },
          profile: profile,
          roles: this.roles
        }

        this.$store.dispatch("dispatchPostUser", { userData: payload }).then((user) => {
          this.$emit("saved", user);
        });

      }
      
    },
    getUserRoles(){
      this.$store.dispatch("dispatchGetUserRoles", { userId: this.user.id }).catch(() => {
        this.roles = [];
      }).then((roles) => {
        if(roles !== undefined){
          console.log(roles);
          this.roles = roles.inherits;
          console.log(roles);
        }
        
      });
    },
    setUserRoles(){
      // TODO
    }
  },
};
</script>
<style scoped>
</style>